import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.1.4_@babel+core@7.26.0_@opentelemetry+api@1.9.0_@playwright+test@1.49.1_react-dom@19._2fh2onridkqe2kwgiiyq7cne5u/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/logo-dark.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn"] */ "/vercel/path0/src/components/animations/fade-in.tsx");
